import { FC, ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { AlertTriangle, Info } from 'lucide-react';

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  description?: ReactNode;
  message?: ReactNode;
  confirmText?: string;
  confirmLabel?: string;
  cancelText?: string;
  variant?: 'danger' | 'primary';
  isLoading?: boolean;
  icon?: ReactNode;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
  title,
  description,
  message,
  confirmText = 'Confirmar',
  confirmLabel,
  cancelText = 'Cancelar',
  variant = 'danger',
  isLoading = false,
  icon,
}) => {
  const handleClose = onClose || onCancel || (() => {});
  const resolvedDescription = description || message;
  const resolvedConfirmText = confirmLabel || confirmText;
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      closeOnBackdrop={!isLoading}
      title={
        <div className="flex items-center gap-2.5">
          {icon ? (
            icon
          ) : variant === 'danger' ? (
            <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-red-500/10 text-red-600 dark:text-red-400">
              <AlertTriangle className="h-4 w-4" />
            </div>
          ) : (
            <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-brand-500/10 text-brand-600 dark:text-brand-400">
              <Info className="h-4 w-4" />
            </div>
          )}
          <span className="text-sm font-semibold text-content-main">
            {title}
          </span>
        </div>
      }
      footer={
        <div className="flex w-full items-center justify-end gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            variant={variant === 'danger' ? 'danger' : 'primary'}
            size="sm"
            isLoading={isLoading}
            onClick={onConfirm}
          >
            {resolvedConfirmText}
          </Button>
        </div>
      }
    >
      <div className="text-xs leading-relaxed text-content-muted">
        {resolvedDescription}
      </div>
    </Modal>
  );
};
